// extracted by mini-css-extract-plugin
export default {"container":"Notifications_container__0f5+s","iconContainer":"Notifications_iconContainer__dLCWX","icon":"Notifications_icon__XqmY4","visible":"Notifications_visible__sQiJO"};